import { useTranslation } from "react-i18next";
import DcDataTable, { DcTableHeader, TableFilterState } from "./dcTable";
import React from "react";
import { useInjection } from "../di/ioc-provider";
import { defaultFilter } from "../pages/DossierPage";
import { beautifyDate, getPageSkipTake, getSkip, sortOnFilter } from "../helpers";
import SearchField from "./searchField";
import { Button, Grid, TableCell, TablePagination, TableRow, Typography } from "@mui/material";
import { ForeignCompany, IUserApiClient } from '../clients/userApiClient';
import { TYPES } from "../di/types";
import GeneralDialog from "./generalDialog";
import { SearchOutlined } from "@mui/icons-material";
import teamleaderLogo from "../assets/TeamleaderIcon.jpg";
import { ConnectedApp } from "../clients/dossierApiClient";
export interface ISearchForViaTeamleaderProps {
    onSelected: (company: ForeignCompany) => void;
}

export const SearchCompaniesViaTeamleader = (props: ISearchForViaTeamleaderProps) => {

    const [t] = useTranslation("common");
    const headers = [
        { name: t("general.companyName"), id: "name" },
        { name: t("general.companyEmail"), id: "email" },
    ] as DcTableHeader[]
    const [loading, setLoading] = React.useState(false);
    const _userClient = useInjection<IUserApiClient>(TYPES.IUserClient);
    const [openOrganisation, setOpenOrganisation] = React.useState(false);

    const [filterState, setFilter] = React.useState<TableFilterState>(defaultFilter);
    const [orgs, setOrgs] = React.useState<ForeignCompany[]>([]);
    const [entityCount, setEntityCount] = React.useState<number>(0);
    const [openDialog, setOpenDialog] = React.useState(false);
    const fetchData = () => {
        setLoading(true);
        _userClient.getCompanies({
            skip: filterState.skip,
            take: filterState.take,
            sortColumn: filterState.sortColumn,
            sortOrder: filterState.sortOrder,
            payload: { search: filterState.search,app :ConnectedApp.Teamleader }
        })
            .then((res) => {
                setEntityCount(res.data.entityCount);
                setOrgs(res.data.data);
            }).catch(() => { })
    }
    React.useEffect(() => {
        if (openDialog)
            fetchData();
    }, [filterState, openDialog])
    const onChangePage = (page: number) => {
        var skip = getSkip(page, filterState.take);
        var copy = { ...filterState };
        copy.skip = skip;
        setFilter(copy);
    }
    const onRowClicked = (list: any) => {
        props.onSelected(list);
        setOpenDialog(false);
        // if (props.onRowClick != undefined) {
        //     props.onRowClick(list);
        // }
    }
    return <>
        <GeneralDialog open={openDialog} onClose={() => { setOpenDialog(false) }}>
            <Grid container spacing={2} style={{paddingBottom:"4px"}}>
                <Grid item><img src={teamleaderLogo}></img></Grid>
                <Grid item style={{
                    position: "relative",
                    top: "12px"
                }}> <Typography color={"#00b2b2"}> {t("general.searchTlCompanyTitle")}</Typography></Grid>
            </Grid>

            <SearchField
                className="full-width"
                onChange={() => { }}
                id="search-departments"
                debouncedWaitTime={500}
                label={t("general.searchTlCompany")}
                onDebouncedSearch={(val) => {
                    var copy = { ...filterState };
                    copy.search = val;
                    setFilter(copy);
                }} />
            <DcDataTable
                headers={headers}
                onFilterClicked={(el) => { setFilter(sortOnFilter(filterState, el)) }}
                filters={filterState}>
                {orgs.map((el) => {
                    return <>
                        <TableRow className="clickable" key={el.id} hover onClick={() => { onRowClicked(el) }}>
                            <TableCell>{el.name}</TableCell>
                            <TableCell>{el.email}</TableCell>
                        </TableRow>
                    </>
                })}
            </DcDataTable>
            {/* <TablePagination
                style={{ marginLeft: "auto", color: "black!important" }}
                rowsPerPageOptions={[50, 100, 200]}
                component="div"
                count={entityCount}
                rowsPerPage={filterState.take}
                page={getPageSkipTake(filterState.skip, filterState.take)}
                onPageChange={(event, page) => { onChangePage(page) }}
                onRowsPerPageChange={(event) => {
                    var copy = { ...filterState };
                    copy.take = Number.parseInt(event.target.value);
                    setFilter(copy);
                }}
            /> */}
        </GeneralDialog>
        <Button style={{ color: "#00b2b2" }} onClick={() => { setOpenDialog(true) }} startIcon={<img src={teamleaderLogo}></img>}>{t("general.SearchCompanyWTeamleader")}</Button>

    </>
}